export const DefaultHeaderTitle = 'typo.00';
export const InvoiceTypes = ['invoice', 'cancellation'];
export const CancellationReasons = [
  'wrong_order',
  'customer_cancelled',
  'tenant_cancelled',
  'test_order',
];
